export const EVENT_DEPOSIT_UPDATE = 'deposit.update'
export const EVENT_DEPOSIT_RATES_CHANGE = 'depositRates.change'
